import React from 'react';

interface FormLabelProps {
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
}

export default function FormLabel({ htmlFor, required, children }: FormLabelProps) {
  return (
    <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700 mb-1.5 h-5">
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
}
